export const CookiesKeys = {
  JWT : 'jwt',
  TOKEN : 'token',
  USER_ID : 'userId',
  TRUSTED : 'trusted',
  TRUSTED_DEVICE : 'trusted_device',
  LOCALE : 'locale',
  LOCATION : 'location',
  AUTHENTICATED_USER : 'authenticatedUser',
};

type CookiesKeysTypes = typeof CookiesKeys[keyof typeof CookiesKeys];

export type { CookiesKeysTypes };
